import { Injectable } from '@angular/core';
import { LoggerService } from '@app/logger/logger.service';
import { ApiBaseService } from './api-base.service';

const log = new LoggerService('ACCESSORIES SERVICE');

@Injectable({
  providedIn: 'root'
})
export class AccessoriesService extends ApiBaseService<any>{

  constructor() {
    // Le pasamos 'accessories' como el nombre del recurso a la clase base
    super('accessories');
    log.debug('Servicio de Accesorios inicializado');
  }

}
